import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import VideoCard from "@/components/VideoCard";

export default function RelatedSpeeches({ speechId }) {
  const [items, setItems] = useState([]);

  useEffect(() => {
    if (!speechId) return;
    api.get(`/speeches/${speechId}/related`).then((r) => setItems(r.data)).catch(() => setItems([]));
  }, [speechId]);

  if (!items.length) return null;

  return (
    <section className="mt-16 pt-10 border-t border-border" data-testid="related-speeches">
      <h2 className="font-serif text-2xl font-bold mb-6">Altri discorsi da vedere</h2>
      <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {items.map((s) => (
          <VideoCard key={s.id} speech={s} />
        ))}
      </div>
    </section>
  );
}
